import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  size?: "narrow" | "default" | "wide";
  as?: keyof JSX.IntrinsicElements;
};

const sizeMap: Record<NonNullable<ContainerProps["size"]>, string> = {
  narrow: "max-w-2xl",
  default: "max-w-5xl",
  wide: "max-w-6xl",
};

export function Container({
  children,
  className,
  size = "default",
  as: Tag = "div",
}: ContainerProps) {
  return (
    <Tag className={cn("mx-auto w-full px-5 sm:px-6 lg:px-8", sizeMap[size], className)}>
      {children}
    </Tag>
  );
}
